module.exports = __webpack_public_path__ + "img/cost.c2ff13d1.svg";